/* ============================================================
   ARCELF — Product page interactions (Phase 3)
   - option rows → variant 解決（価格/在庫/hidden id 更新）
   - quantity - / +
   - size guide modal open/close (Esc / overlay click)
   依存なし・プレーン JS
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-arcelf-product]');
  if (!root) return;

  /* ---------- variants ---------- */
  var dataEl = document.getElementById('arcelf-pd-variants');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { /* noop */ }

  var idInput = root.querySelector('[data-pd-variant-id]');
  var priceEl = root.querySelector('[data-pd-price]');
  var atcBtn = root.querySelector('[data-pd-atc]');

  var optionRows = root.querySelectorAll('[data-pd-option]');

  function selectedOptions() {
    var opts = [];
    optionRows.forEach(function (row) {
      var checked = row.querySelector('input:checked');
      opts.push(checked ? checked.value : null);
    });
    return opts;
  }

  function findVariant(opts) {
    /* オプションを持たない商品（Default Title のみ）はオプション行が1つも描かれない。
       この場合 opts が [] になり every() が必ず false を返すため、旧実装では
       バリアント解決に失敗して add to cart が「unavailable」で固定されていた。
       ワンサイズのピアス・ブレス・ネックレスを登録した瞬間に売れなくなるので、
       行数とオプション数が一致しないときは唯一のバリアントへフォールバックする。 */
    if (!optionRows.length) return variants[0];
    return variants.find(function (v) {
      return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  /* サイズ未選択のままカートに入れられないようにする＝誤サイズ注文の防止。
     - properties[Size] で受ける商品（サイズ未登録のリング）: [data-pd-size-prop]
     - バリアントで受ける商品（サイズ登録済みのリング）:     [data-pd-size-required] */
  var sizeRow = root.querySelector('[data-pd-size-prop]');
  var sizeVariantRow = root.querySelector('[data-pd-size-required]');
  var expressWrap = root.querySelector('[data-pd-express]');

  function selectedSize() {
    if (!sizeRow) return null;
    var checked = sizeRow.querySelector('input[data-pd-size]:checked');
    return checked ? checked.value : null;
  }
  function sizeVariantChosen() {
    if (!sizeVariantRow) return true;
    return !!sizeVariantRow.querySelector('input:checked');
  }

  function lockExpress(locked) {
    if (!expressWrap) return;
    expressWrap.classList.toggle('is-locked', !!locked);
    expressWrap.setAttribute('aria-hidden', locked ? 'true' : 'false');
    /* 見た目のロック（opacity / pointer-events）だけだとキーボードから押せるので、フォーカスも遮断する */
    if ('inert' in expressWrap) expressWrap.inert = !!locked;
  }

  function showUnavailable() {
    if (idInput) idInput.value = '';
    if (priceEl) priceEl.textContent = '';
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.removeAttribute('data-needs-size');
      atcBtn.textContent = atcBtn.dataset.labelUnavailable;
    }
    lockExpress(true);
  }

  function showCandidatePrice(opts) {
    var candidates = variants.filter(function (v) {
      return v.options.length === opts.length && v.options.every(function (o, i) {
        return opts[i] === null || o === opts[i];
      });
    });
    if (!candidates.length) return false;

    var lowest = candidates.reduce(function (min, v) { return v.price < min.price ? v : min; });
    var varies = candidates.some(function (v) { return v.price !== lowest.price; });
    var label = lowest.price_formatted;
    if (varies) {
      var language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
      if (language === 'ja') label += '〜';
      else if (language === 'fr') label = 'À partir de ' + label;
      else label = 'From ' + label;
    }
    if (priceEl) priceEl.textContent = label;
    return true;
  }

  function updateVariant() {
    var needsSize = (!!sizeRow && !selectedSize()) || !sizeVariantChosen();
    var opts = selectedOptions();

    /* サイズのバリアントを未選択のままにしている段階では、まだ商品が特定できない。
       選択素材の最低価格は表示するが、購入用の ID はサイズ選択まで空にする。 */
    if (!sizeVariantChosen()) {
      if (!showCandidatePrice(opts)) {
        showUnavailable();
        return;
      }
      if (idInput) idInput.value = '';
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('data-needs-size', 'true');
        atcBtn.textContent = atcBtn.dataset.labelSelectSize || 'select a size';
      }
      lockExpress(true);
      return;
    }

    var v = findVariant(opts);

    if (!v) {
      showUnavailable();
      return;
    }
    lockExpress(!v.available || needsSize);
    if (idInput) idInput.value = v.id;
    if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
    if (atcBtn) {
      if (!v.available) {
        atcBtn.disabled = true;
        atcBtn.removeAttribute('data-needs-size');
        atcBtn.textContent = atcBtn.dataset.labelSoldout;
      } else if (needsSize) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('data-needs-size', 'true');
        atcBtn.textContent = atcBtn.dataset.labelSelectSize || 'select a size';
      } else {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('data-needs-size');
        atcBtn.textContent = atcBtn.dataset.labelAdd;
      }
    }
    /* バリアント画像がある場合は該当ギャラリー画像へスクロール（gold/silver 切替） */
    if (v.featured_media_id) {
      var img = document.querySelector('[data-pd-media="' + v.featured_media_id + '"]');
      if (img && window.matchMedia('(min-width: 900px)').matches === false) {
        img.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  root.querySelectorAll('[data-pd-option] input').forEach(function (input) {
    input.addEventListener('change', updateVariant);
  });
  if (sizeRow) {
    sizeRow.querySelectorAll('input[data-pd-size]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
  }
  updateVariant();

  /* ---------- quantity ---------- */
  var qtyInput = root.querySelector('[data-pd-qty]');
  var qtyLabel = root.querySelector('[data-pd-qty-label]');
  root.querySelectorAll('[data-pd-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(btn.dataset.pdQtyStep, 10);
      var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      qtyInput.value = next;
      if (qtyLabel) qtyLabel.textContent = next;
    });
  });

  /* ---------- size guide modal ---------- */
  var overlay = document.getElementById('arcelf-sg-overlay');
  function openSG() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.classList.add('arcelf-sg-lock');
    var closeBtn = overlay.querySelector('.arcelf-sg__close');
    if (closeBtn) closeBtn.focus();
  }
  function closeSG() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('arcelf-sg-lock');
  }
  document.querySelectorAll('[data-pd-sg-open]').forEach(function (btn) {
    btn.addEventListener('click', openSG);
  });
  if (overlay) {
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSG(); });
    overlay.querySelectorAll('[data-pd-sg-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSG);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSG();
  });
})();
